"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VideoPlayerIds;
(function (VideoPlayerIds) {
    VideoPlayerIds["VideoContainer"] = "sendspark-video-container";
    VideoPlayerIds["VideoPlayer"] = "sendspark-video-player";
    VideoPlayerIds["ButtonPlay"] = "sendspark-video-player-button-play";
    VideoPlayerIds["ButtonVolume"] = "sendspark-video-player-button-volume";
    VideoPlayerIds["ButtonPlaybackRate"] = "sendspark-video-player-button-playback-rate";
    VideoPlayerIds["InputVolumeRange"] = "sendspark-video-player-input-volume-range";
    VideoPlayerIds["ButtonFullscreen"] = "sendspark-video-player-button-fullscreen";
    VideoPlayerIds["ProgressBar"] = "sendspark-video-player-progress-bar";
    VideoPlayerIds["ProgressBarCustomIntro"] = "sendspark-video-player-progress-bar-custom-intro";
    VideoPlayerIds["ButtonNextVideo"] = "sendspark-video-player-button-next-video";
})(VideoPlayerIds || (VideoPlayerIds = {}));
exports.default = VideoPlayerIds;
